import React from 'react';
import classnames from 'classnames/bind';
import { Replacement } from '../../interface';
import { ReactComponent as VehicleOwner } from '../../images/vehicle-owner.svg';
import { ReactComponent as WorkshopOwner } from '../../images/workshop-owner.svg';
import { ReactComponent as VehicleInvertedOwner } from '../../images/vehicle-owner-inverted.svg';
import { ReactComponent as WorkshopInvertedOwner } from '../../images/workshop-owner-inverted.svg';
import { ReactComponent as ArrowRight } from '../../images/angle-circle-arrow-right-icon.svg';
import { ReactComponent as DownloadReport } from '../../images/bp-icon-download-white.svg'
import style from './index.module.scss';
import localesReplacement from '../../utils/localesReplacement';
import pdf from '../../docs/Castrol Carbon Neutral Products Marketed in France v1.0 (Clean Version) Final Version.pdf'

const cx = classnames.bind(style);

interface Props {
  replacements: Replacement;
  selectedIndex?: boolean;
  setSelectedIndex: (v: boolean) => void;
}

function OwnerSelector(props: Props) {
  const { selectedIndex, setSelectedIndex, replacements } = props;

  const downlaodReport = () => {
    const a = document.createElement('a');
    a.href = pdf;
    a.download = 'Castrol Carbon Neutral Products.pdf';
    a.click();
  }

  return (
    <div className={cx('owner-selector')}>
      <div className={cx('selected-role')}>
        {selectedIndex ? (
          <>
            <WorkshopOwner data-testid="workshop-owner-icon"/>
            <span>{localesReplacement(replacements, 'WORKSHOP OWNER')}</span>
          </>
        ) : (
          <>
            <VehicleOwner data-testid="vehicle-owner-icon"/>
            <span>{localesReplacement(replacements, 'VEHICLE OWNER')}</span>
          </>
        )}
      </div>
      {'FRA' === localStorage.getItem('countryCode') && (
        <div className={cx('button-container')}>
          <button
            className={cx('report-button')}
            style={{ color: 'white', padding: '10px' }}
            onClick={() => {
              downlaodReport();
            }}>
            <div style={{ width: '220px', textAlign: 'left' }}>{localesReplacement(replacements, 'Click here to download the full report')}</div>
            <div style={{ marginLeft: '20px', color: 'rgb(220, 220, 220)', marginTop: '10px' }}>PDF / 932 KB</div>
            < DownloadReport data-testid="Click here to download the full report" style={{ marginLeft: '10px', color: 'rgb(220, 220, 220)', width: '20px', height: '20px', marginTop: '10px' }} />
          </button>
        </div>
      )
      }

      <div className={cx('alternative-role')}>
        <div className={cx('separator')}></div>
        {selectedIndex ? (
          <div className={cx('content')}>
            <VehicleOwner data-testid="vehicle-owner-icon" />
            <div>
              <small>{localesReplacement(replacements, 'Are you a')}</small>{' '}
              {localesReplacement(replacements, 'VEHICLE OWNER')}?
            </div>
          </div>
        ) : (
          <div className={cx('content')}>
            <WorkshopOwner data-testid="workshop-owner-icon"/>
            <div>
              <small>{localesReplacement(replacements, 'Are you a')}</small>{' '}
              {localesReplacement(replacements, 'WORKSHOP OWNER')}?
            </div>
          </div>
        )}

        <div className={cx('switch-button')}>
          <i onClick={() => setSelectedIndex(!selectedIndex)}>
            <ArrowRight fill='#009343' className={cx('circular')} />
          </i>
        </div>
      </div>
      <div className={cx('alternative-role-mobile')}>
        <i onClick={() => setSelectedIndex(!selectedIndex)}>
          {selectedIndex ? <WorkshopInvertedOwner /> : <VehicleInvertedOwner />}
        </i>
      </div>
    </div>
  );
}

export default OwnerSelector;